import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class TransportistaService {
  id: any
  transportistas:any =[]

  constructor() { }

  getAllTransportistas(){
    return gql`
      query getAllTransportistas {
          transportistas(sort: "createdAt:DESC") {
            id
            nombre
            cif
            nima
            nombreContacto
            estado
            documentos{
              estado
              tipo
            }
          }
        }
    `;
  }

  getAllTransportistasDoughnout(){
    return gql`
      query getAllTransportistas {
          transportistas(sort: "createdAt:DESC") {
            id
            estado
            documentos{
              tipo
              estado
            }
          }
        }
    `;
  }

  getTransportistaById(){
    return gql`
      query getTransportistaById($id: ID!) {
          transportista(id: $id) {
            id
            nombre
            cif
            codigo
            nima
            nombreContacto
            mailContacto
            contratistas{
              nombreComercial
            }
            contratistaContacto {
              nombre
              mail
              contratista 
            }
            comentariosAutorizacion1{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion2{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion3{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion4{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion5{
              causa
              fecha
              comentario
            }
          }
        }
    `;
  }

  getTransportista(){
    return gql`
      query getTransportista($id: ID!) {
          transportista(id: $id) {
            id
            centros {
              id
              contratista {
                id
              }
            }
          }
        }
    `;
  }

  addTransportista(){
    return gql`
      mutation createTransportista($input: createTransportistaInput!) {
      createTransportista(input: $input) {
        transportista {
          id
        }
      }
    }
    `;
  }

  updateTransportista(){
    return gql`
      mutation updateTransportista($input: updateTransportistaInput!) {
        updateTransportista(input: $input) {
          transportista {
            id
            estado
          }
        }
      }
    `;
  }

  updateTransportistaCentros(){
    return gql`
      mutation updateTransportista($input: updateTransportistaInput!) {
        updateTransportista(input: $input) {
          transportista {
            id
            centros {
              id
            }
          }
        }
      }
    `;
  }

  deleteTransportista(){
    return gql`
      mutation deleteTransportista($input: deleteTransportistaInput!) {
        deleteTransportista(input: $input) {
          transportista {
            id
          }
        }
      }
    `;
  }

  getAllTransportistasYellow(){
    return gql`
      query getAllTransportistas {
          transportistas (
            where: {
              estado: "amarillo"
            }
          ){
            id
            nombre
            cif
            nima
            nombreContacto
            estado
            documentos{
              estado
              tipo
            }
          }
        }
    `;
  }

  getAllTransportistasGreen(){
    return gql`
      query getAllTransportistas {
          transportistas (
            where: {
              estado: "verde"
            }
          ){
            id
            nombre
            cif
            nima
            nombreContacto
            estado
            documentos{
              estado
              tipo
            }
          }
        }
    `;
  }

  getAllTransportistasRed(){
    return gql`
      query getAllTransportistas {
          transportistas (
            where: {
              estado: "rojo"
            }
          ){
            id
            nombre
            cif
            nima
            nombreContacto
            estado
            documentos{
              estado
              tipo
            }
          }
        }
    `;
  }

   setIdTransportista(id:any){
    this.id = id; 
  }

  getIdTransportista(){
   let temp = this.id;
    this.clearIdTransportista();
    return temp;
  }

  clearIdTransportista(){
    this.id = undefined;
  }

  setTransportistas(transportistas:any){
    this.transportistas = transportistas; 
  }

  getTransportistas(){
   let temp = this.transportistas;
    this.clearTransportistas();
    return temp;
  }

  clearTransportistas(){
    this.transportistas = [];
  }

}
